import React, { useState } from 'react'
import styled from '@emotion/styled'
import { css, keyframes } from '@emotion/core'
import { device } from '../../devices'
import { TitleGradientHome } from '../title'
import { GlobalContainer } from '../container/GlobalContainer'
import { Text } from '../text'
import LogoLoreal from '../../images/logo_loreal.inline.svg'

export const SoftwareClientReviews = ({intl}) => {
  const [index, setIndex] = useState(1)
  return (
    <GlobalContainer>
      <TitleGradientHomeClientReview
        css={css`
          @media ${device.mobileL} {
            opacity: 1;
            margin-top: 77px;
            margin-left: 0 !important;
          }
        `}
        data-sal="slide-up" data-sal-duration="500" data-sal-easing="ease"
        dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.title_client_review'})}}/>
      <ContainerReviews>
        <Review selected={index === 0} left={0} onMouseEnter={() => setIndex(0)}>
          <img src={require('../../images/logo-schoolab.png')} width={'50%'}/>
          <Text dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.Schoolab'})}}/>
        </Review>
        <Review selected={index === 1} zIndex={1} onMouseEnter={() => setIndex(1)}>
          <img src={require('../../images/logo-luni.png')} width={'20%'}/>
          <Text dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.Lunii'})}}/>
        </Review>
        <Review right={0} selected={index === 2} onMouseEnter={() => setIndex(2)}>
          <LogoLoreal/>
          <Text dangerouslySetInnerHTML={{__html: intl.formatMessage({id: 'software_page.Loreal'})}}/>
        </Review>
      </ContainerReviews>
    </GlobalContainer>
  )
}

const TitleGradientHomeClientReview = styled(TitleGradientHome)`
margin-left: 10vw;

@media ${device.mobileL} {
  width:100%;
  text-align:center;
  padding:35px 0 20px;
}
`
const ContainerReviews = styled.div`
  height: 40vw;
  display:flex;
  align-items: center;
  justify-content: center;
  z-index: -20;
  
  @media ${device.mobileL} {
    flex-direction: column;
    height: auto;
  }
`
const swipFirst = keyframes` 
  90% {
    z-index: 1;
  }
  100% {
    z-index: 100000;
  }
`

const Review = styled.div`
  width: ${({selected}) => selected ? '32.2vw' : '32.2vw'};
  height: ${({selected}) => selected ? '24.8vw' : '24.8vw'};
  border: 0.3vw solid ${({theme}) => theme.primary};
  border-radius: 6.3vw;
  background: ${({selected, theme: {primary, white}}) => selected ? primary : white};
  box-shadow: ${({selected}) => selected ? '0.195vw 0.195vw 1.367vw 0 rgba(0, 0, 0, 0.43)' : ''};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: absolute;
  cursor: pointer;
  transition: all .3s ease-in-out;
  animation: ${({selected}) => selected ? css`${swipFirst} linear forwards` : 'initial'};
 
  &:nth-of-type(1) {
    left: 0vw;
    top: 14vw;
    transform: rotate(-10deg);     
    z-index:2;
    transition: all .3s ease-in-out;
    
    @media ${device.mobileL} {
      top: 6vw;
    }
  }
  
  &:nth-of-type(2) {
    z-index:1000;
    transform: rotate(3deg);
    top: 17vw;
    transition: all .3s ease-in-out;
    @media ${device.mobileL} {
      top: 10vw;
    }
  }
  
  &:nth-of-type(3) {
    right: 0vw;
    top: 14vw;
    z-index:1;
    transform: rotate(10deg);
    transition: all .3s ease-in-out;
  }
  
  p {
    color: ${({selected, theme: {black, white}}) => selected ? white : black};
    width: ${({selected}) => selected ? '24vw' : '24vw'};
    font-size:  ${({selected}) => selected ? '1.1vw' : '1.1vw'};
    text-align:center;
    margin-top: 2.5vw;
    font-weight: 400;
    transition: all .3s ease-in-out;
    
    b {
      font-size: 1.3vw;
      line-height: 3vw;
    }
    
    &:nth-of-type(1) {
      margin: 2vw 0;
    }
  }
  
  svg {
    fill: ${({selected, theme: {black, white}}) => selected ? white : black};
    width: auto;
    height: ${({selected}) => selected ? '3.7vw' : '3.7vw'}; 
    transition: fill 0.1s ease-in-out;
    transition: all .3s ease-in-out;
  }
  
  @media ${device.mobileL} {
    position: relative;
    height: auto;
    transform: rotate(0) !important;
    width: 100%;
    display: flex;
    justify-content: space-around;
    margin: 42px 0;
    border: 1px solid ${({theme}) => theme.white};
    background: ${({theme}) => theme.white};
    
    p {
      width: 90%;
      font-size: 100% !important;
      margin-bottom: 2vw;
      color: ${({theme}) => theme.black} !important;
    }
    svg {
        height: 30px;
        margin: 10px 0;
        fill: ${({theme}) => theme.black} !important;
    }
  }
`
